import { useIntl } from 'react-intl';
import ErrorAlert from '@/shared/components/ErrorAlert';
import { GoogleIcon } from './OAuthIcons';

interface Props {
  onOAuth: (provider: 'google_oauth2' | 'microsoft_graph' | 'facebook') => void;
  error: string | null;
}

const oauthButtonClassName =
  'w-full inline-flex items-center justify-center gap-2 rounded-md border border-slate-200 bg-white/90 px-3 py-2.5 text-xs font-semibold text-slate-600 transition hover:border-brand-300 hover:bg-white hover:text-brand-700';

export default function OAuthButtons({ onOAuth, error }: Props) {
  const intl = useIntl();

  const oauthProviders = [
    { id: 'google_oauth2', label: intl.formatMessage({ id: 'auth.oauth.google' }), Icon: GoogleIcon },
    // { id: 'microsoft_graph', label: intl.formatMessage({ id: 'auth.oauth.microsoft' }), Icon: MicrosoftIcon },
    // { id: 'facebook', label: intl.formatMessage({ id: 'auth.oauth.facebook' }), Icon: FacebookIcon },
  ] as const;

  return (
    <div className="mt-6 space-y-3">
      <div className="grid w-full gap-3 grid-cols-1">
        {oauthProviders.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => onOAuth(id)}
            className={oauthButtonClassName}
          >
            <Icon className="h-4 w-4" />
            {label}
          </button>
        ))}
      </div>
      {error && <ErrorAlert message={error} />}
    </div>
  );
}
